import React, { useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

/**
 * Reusable flatpickr date picker wrapper.
 * Props:
 *   value        – controlled date string (YYYY-MM-DD)
 *   onChange     – called with (dateString) whenever date changes
 *   placeholder  – input placeholder text
 *   className    – extra class names for the input
 *   options      – extra flatpickr options to merge in
 */
const FlatpickrInput = ({
  value,
  onChange,
  placeholder = 'Select date',
  className = '',
  options = {},
  disabled = false,
}) => {
  const inputRef = useRef(null);
  const fpRef    = useRef(null);

  useEffect(() => {
    fpRef.current = flatpickr(inputRef.current, {
      dateFormat: 'Y-m-d',
      allowInput: true,
      ...options,
      onChange: (selectedDates, dateStr) => {
        onChange(dateStr);
      },
    });
    return () => {
      if (fpRef.current) fpRef.current.destroy();
    };
  }, []); // eslint-disable-line

  // Sync external value changes into flatpickr
  useEffect(() => {
    if (fpRef.current) {
      if (value) {
        fpRef.current.setDate(value, false);
      } else {
        fpRef.current.clear();
      }
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      className={`w-full px-4 py-3 rounded-xl border text-slate-900 text-sm outline-none transition cursor-pointer ${className}`}
      style={{borderColor:'#f9b8ca',background:'#fdf0f4'}}
      onFocus={e=>{e.target.style.borderColor='#c44569';e.target.style.boxShadow='0 0 0 3px rgba(196,69,105,0.15)';e.target.style.background='#fff'}}
      onBlur={e=>{e.target.style.borderColor='#f9b8ca';e.target.style.boxShadow='none';e.target.style.background='#fdf0f4'}}
      placeholder={placeholder}
      defaultValue={value}
      disabled={disabled}
      readOnly={false}
      autoComplete="off"
    />
  );
};

export default FlatpickrInput;
